import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'carbon-radion-group',
  templateUrl: './carbon-radion-group.component.html',
  styleUrls: ['./carbon-radion-group.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CarbonRadionGroupComponent),
      multi: true
    }
  ]
})
export class CarbonRadionGroupComponent implements OnInit, ControlValueAccessor {
  @Input() label!: string;
  @Input() name: string = 'radio-group';
  @Input() readonly: boolean;
  @Input() required = false;
  @Input() options: { val: string; label: string; tooltip?: string }[] = [];
  @Input() showFieldSet: boolean = false;
  @Output() valueChange = new EventEmitter<string>();
  @Input() control!: FormControl;
  @Input() hidden: boolean = false;
  @Input() orientation: 'vertical' | 'horizontal' = 'vertical';

  value: string | null = null;
  disabled = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};
  constructor() { }

  ngOnInit() {
  }

  get class(): string {
    if(this.showFieldSet == true) {
      return 'conditional-section show';
    }else{
      return '';
    }
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectValue(value: string) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
    // emitir também para quem escuta via output (consistência com checkbox)
    try { this.valueChange.emit(value); } catch (e) { /* noop */ }
  }
}
